var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"id":"payment-form"}},[_c('div',{attrs:{"id":"payment-element"}}),_vm._v(" "),_c('button',{ref:"stripeSubmit",staticStyle:{"display":"none"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }